export interface OrderItemGroup {
  key: string;
  kind: "meal" | "drink" | "addon";
  name: string;
  quantity: number;
  detail?: string;
  indices: number[];
  swapped?: boolean;
}

export function getOrderItems(order: any): OrderItemGroup[] {
  const groups = new Map<string, OrderItemGroup>();
  const count = order.peopleCount || 1;
  const add = (item: OrderItemGroup) => {
    const existing = groups.get(item.key);
    if (existing) {
      existing.quantity += item.quantity;
      existing.indices.push(...item.indices);
      existing.swapped ||= item.swapped;
    } else groups.set(item.key, item);
  };
  for (const kind of ["meal", "drink"] as const) {
    const field = kind === "meal" ? "mealId" : "drinkId";
    const list = kind === "meal" ? order.meals : order.drinks;
    const explicit = list?.length > 0;
    const rows = explicit ? list : order[field] ? [{ [field]: order[field] }] : [];
    rows.forEach((row: any, index: number) => {
      const item = row[field] || order[field];
      if (!item) return;
      const name = item.name || (kind === "meal" ? "Unknown Meal" : "Drink");
      const portion = (row.portionSize || order.portionSize || order.subscriptionId?.portionSize || "classic").toLowerCase();
      const detail = kind === "meal" ? (portion === "light" ? "Light" : "Classic")
        : [((item.type || row.drinkType) === "blend" ? "Blend" : "Coffee"), row.customizations?.milk, row.customizations?.sweetness].filter(Boolean).join(" · ");
      add({ key: `${kind}:${item._id || name}:${detail}`, kind, name, detail,
        quantity: explicit ? 1 : count, indices: [index], swapped: !!row.isSwapped });
    });
  }
  (order.addOns || []).forEach((addon: any) => {
    const name = typeof addon === "string" ? addon : addon?.name || addon?.title || addon?.addOnId?.name || "Add-on";
    const quantity = typeof addon?.quantity === "number" && addon.quantity > 0 ? addon.quantity : count;
    add({ key: `addon:${name}`, kind: "addon", name, quantity, detail: "Add-on", indices: [] });
  });
  if (order.subscriptionId?.planId?.title === "Power Morning Plan") {
    add({ key: "included:coconut", kind: "addon", name: "Coconut Water", quantity: count, detail: "Included", indices: [] });
  }
  return Array.from(groups.values());
}
